export default {
  // 通用
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    loading: 'Loading...',
    retry: 'Retry',
    submit: 'Submit',
    search: 'Search',
    clear: 'Clear',
    select: 'Select',
    pleaseSelect: 'Please select',
    noData: 'No data',
    noMore: 'No more data',
    guest: 'Guest',
    free: 'Free'
  },

  // 导航和页面标题
  nav: {
    home: 'Home',
    about: 'About',
    news: 'News',
    profile: 'Profile',
    products: 'Products',
    productList: 'Product List',
    productDetail: 'Product Detail',
    customizeOrder: 'Customize Order',
    orderConfirm: 'Order Confirmation',
    orderList: 'Order List',
    orderDetail: 'Order Detail',
    addressManage: 'Address Management',
    addressEdit: 'Edit Address',
    payment: 'Payment',
    share: 'Share'
  },

  // 商品相关
  product: {
    // 商品类型
    inStock: 'In Stock',
    custom: 'Custom',
    presale: 'Presale',
    
    // 商品信息
    name: 'Product Name',
    price: 'Price',
    originalPrice: 'Original Price',
    deposit: 'Deposit',
    depositLabel: 'Deposit',
    customAmount: 'Custom Amount (Deposit)',
    productAmount: 'Product Amount',
    sales: 'Sold {count} pieces',
    description: 'Description',
    specs: 'Specifications',
    selectSpecs: 'Select Specifications',
    size: 'Size',
    color: 'Color',
    deliveryTime: 'Delivery Time',
    loadingTypes: 'Loading product types...',
    apiResponse: 'API Response:',
    processedData: 'Processed Data:',
    categoriesLoaded: 'Categories loaded successfully:',
    invalidDataFormat: 'API returned data is not in array format:',
    invalidDataFormatError: 'API data format error',
    loadTypesFailed: 'Failed to load product types:',
    errorDetails: 'Error Details:',
    loadTypesFailedMsg: 'Failed to load category data',
    usingDefaultData: 'Using default category data',
    all: 'All',
    women: 'Women',
    men: 'Men',
    accessories: 'Accessories',
    shoes: 'Shoes',
    
    // 商品详情
    productInfo: 'Product Information',
    productParams: 'Product Parameters',
    sizeChart: 'Size Chart',
    sizeReference: 'Size Reference',
    sizeDetails: 'Size Details',
    customNotice: 'Custom Notice',
    friendlyTips: 'Friendly Tips',
    
    // 商品操作
    buyNow: 'Buy Now',
    customNow: 'Customize Now',
    addToCart: 'Add to Cart',
    outOfStock: 'Out of Stock',
    
    // 发货时间
    shipIn24Hours: 'Ships within 24 hours',
    shipInHours: 'Ships within {hours} hours',
    shipInDays: 'Ships within {days} days',
    
    // 商品搜索和筛选
    searchPlaceholder: 'Search products',
    sortBy: 'Sort by',
    comprehensive: 'Comprehensive',
    priceSort: 'Price',
    salesSort: 'Sales',
    ratingSort: 'Rating',
    
    // 商品提示
    customProductTip: 'Custom products require careful verification of size information. If you have any questions, please contact customer service.',
    stockProductTip: 'In-stock and pre-sale products require careful verification of size information. It is recommended to refer to the size chart to select the appropriate size. If you have any questions, please contact customer service.',
    
    // 规格选择
    pleaseSelectSpecs: 'Please select specifications',
    specDetails: 'Specification Details',
    paramDetails: 'Parameter Details',
    specParamCombination: 'Specification Parameter Combination',
    specCombination: 'Specification Combination',
    paramCombination: 'Parameter Combination',
    viewDetails: 'View Details',
    defaultSpecs: 'Default Specifications',
    
    // 尺码相关
    heightWeight: 'Height\\Weight',
    bodyPart: 'Body',
    sizeNumber: 'Size',
    referenceOnly: 'The above data is for reference only. Actual sizes may vary due to fabric and craftsmanship.',
    
    // 定制相关
    customRequirements: 'Custom Requirements',
    customParams: 'Custom Parameters',
    noCustomNotice: 'No custom notice available',
    
    // 图片相关
    productImage: 'Product Image',
    noImage: 'No image available',
    swipeUpForDetails: 'Swipe up to view details'
  },

  // 用户相关
  user: {
    // 登录状态
    notLoggedIn: 'Not logged in',
    loggedIn: 'Logged in',
    loginRequired: 'Please log in first',
    loginSuccess: 'Login successful!',
    logoutSuccess: 'Logged out successfully',
    
    // 登录方式
    wechatLogin: 'WeChat Login',
    wechatQRLogin: 'WeChat QR Login',
    wechatAuth: 'WeChat Authorization',
    bindPhone: 'Bind Phone Number',
    clickToLogin: 'Click to log in with WeChat',
    clickToBind: 'Click to bind phone number',
    
    // 用户信息
    userInfo: 'User Information',
    nickname: 'Nickname',
    avatar: 'Avatar',
    phone: 'Phone Number',
    wechatUser: 'WeChat User',
    clickAvatarToLogout: 'Click avatar to log out',
    
    // 登录相关提示
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    pleaseOpenInWechat: 'Please open in WeChat',
    redirectingToWechat: 'Redirecting to WeChat authorization...',
    scanQRToLogin: 'Scan QR code to log in',
    confirmLoginOnPhone: 'Please confirm login on your phone after scanning',
    qrExpired: 'QR code expired, please regenerate',
    regenerateQR: 'Regenerate',
    generatingQR: 'Generating QR code...',
    openWechatLogin: 'Open WeChat Login Page'
  },

  // 订单相关
  order: {
    // 订单状态
    myOrders: 'My Orders',
    allOrders: 'All Orders',
    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    pendingReceive: 'Pending Receive',
    completed: 'Completed',
    
    // 订单操作
    createOrder: 'Create Order',
    confirmOrder: 'Confirm Order',
    submitOrder: 'Submit Order',
    submitCustomOrder: 'Submit Custom Order',
    payNow: 'Pay Now',
    confirmReceive: 'Confirm Receipt',
    viewOrder: 'View Order',
    
    // 订单信息
    orderNumber: 'Order Number',
    orderTime: 'Order Time',
    orderAmount: 'Order Amount',
    orderStatus: 'Order Status',
    orderRemark: 'Order Remark',
    orderRemarkPlaceholder: 'Optional, please enter order remarks',
    
    // 订单详情
    orderDetail: 'Order Details',
    productInfo: 'Product Information',
    orderInfo: 'Order Information',
    paymentInfo: 'Payment Information',
    logisticsInfo: 'Logistics Information',
    
    // 支付相关
    paymentMethod: 'Payment Method',
    offlinePayment: 'Offline Payment',
    offlinePaymentDesc: 'Pay in store or upon delivery',
    airwallexPay: 'Airwallex',
    airwallexPayDesc: 'Secure payment via Airwallex',
    totalAmount: 'Total Amount',
    actualPayment: 'Actual Payment',
    
    // 配送相关
    deliveryMethod: 'Delivery Method',
    expressDelivery: 'Express Delivery',
    storePickup: 'Store Pickup',
    deliveryFee: 'Delivery Fee',
    deliveryTime: 'Delivery Time',
    workDaysDelivery: '{days} working days delivery',
    storePickupFree: 'Store pickup, free shipping',
    
    // 新增的翻译
    defaultStore: 'Main Store (Default)',
    pickupInStore: 'Please pick up in store',
    businessHours: 'Business Hours: 09:00-18:00',
    pickupTip: 'No shipping address required for in-store pickup. Please present your order information when picking up',
    
    // 其他订单相关
    submittingOrder: 'Submitting order data:',
    currentPaymentMethod: 'Current selected payment method:',
    processingPayment: 'Starting to process payment flow:',
    phoneNumberTooLong: 'Phone number is too long (max {maxLength} characters), it will be truncated'
  },

  // 地址相关
  address: {
    // 地址管理
    addressManagement: 'Address Management',
    shippingAddress: 'Shipping Address',
    selectAddress: 'Select Address',
    addAddress: 'Add Address',
    editAddress: 'Edit Address',
    deleteAddress: 'Delete Address',
    setDefault: 'Set as Default',
    defaultAddress: 'Default',
    addAddressFeature: 'Add address feature under development',
    pleaseSelectAddress: 'Please select shipping address',
    noAddress: 'No shipping address available',
    addressRequired: 'Shipping address is required',
    
    // 地址信息
    consignee: 'Consignee',
    phoneNumber: 'Phone Number',
    region: 'Region',
    detailAddress: 'Detailed Address',
    postalCode: 'Postal Code',
    
    // 地址表单
    consigneePlaceholder: 'Please enter consignee name',
    phonePlaceholder: 'Please enter phone number',
    regionPlaceholder: 'Please select region',
    detailPlaceholder: 'Please enter detailed address',
    postalPlaceholder: 'Please enter postal code'
  },

  // 分享相关
  share: {
    shareTitle: 'Share',
    shareTo: 'Share to',
    shareToFriends: 'Share to Friends',
    shareToMoments: 'Share to Moments',
    sharePreview: 'Share Preview',
    shareSuccess: 'Share configured successfully, please click the menu in the upper right corner to share',
    shareFailed: 'Share configuration failed, please try again',
    configuring: 'Configuring share...',
    shareComplete: 'Share configuration complete, please click the menu in the upper right corner to share',
    
    // Default share content
    defaultTitle: 'Tatar Trade Mall',
    defaultDesc: 'Providing high-quality products to global customers',
    
    // 分享提示
    pleaseOpenInWechat: 'Please open in WeChat',
    shareConfigComplete: 'Share configuration complete, please click the menu in the upper right corner to share to friends',
    shareMomentsComplete: 'Share configuration complete, please click the menu in the upper right corner to share to moments'
  },

  // 客服相关
  service: {
    customerService: 'Customer Service',
    contactService: 'Contact Customer Service',
    scanQRForService: 'Scan QR code to add official customer service',
    connectingService: 'Connecting you to customer service...',
    ifYouHaveQuestions: 'If you have any questions',
    scanToAddService: 'Please scan to add official customer service'
  },

  // 表单相关
  form: {
    required: 'This field is required',
    pleaseEnter: 'Please enter {field}',
    pleaseSelect: 'Please select {field}',
    pleaseComplete: 'Please complete {field}',
    invalidFormat: 'Invalid format',
    
    // 签名相关
    signatureConfirm: 'Signature Confirmation',
    pleaseSignAbove: 'Please sign in the area above',
    clearSignature: 'Clear',
    signatureRequired: 'Signature is required'
  },

  // 错误和提示
  error: {
    loadFailed: 'Load failed',
    loadFailedRetry: 'Load failed, please retry',
    networkError: 'Network error',
    systemError: 'System error',
    operationFailed: 'Operation failed',
    dataError: 'Data error',
    productIdNotExist: 'Product ID does not exist',
    loadingFailed: 'Loading failed, please try again',
    notLoggedIn: 'You are not logged in, please log in',
    customNotSupported: 'This product does not support customization',
    outOfStock: 'Product is out of stock',
    connectingService: 'Connecting you to customer service...',
    
    // 商品相关错误
    productNotFound: 'Product not found',
    productIdMissing: 'Product ID is missing',
    specSelectionRequired: 'Please select product specifications',
    insufficientStock: 'Insufficient stock',
    productLoadFailed: 'Failed to load product information',
    specInfoLoadFailed: 'Failed to get product specification information',
    specValueParseFailed: 'Failed to parse specification value ID',
    orderDataParseFailed: 'Failed to parse order data',
    
    // 用户相关错误
    loginFailed: 'Login failed, please try again',
    authFailed: 'Authorization failed, please check domain configuration',
    authTimeout: 'Authorization timeout, please try again',
    
    // 订单相关错误
    orderCreateFailed: 'Failed to create order',
    orderSubmitFailed: 'Failed to submit order',
    addressRequired: 'Please select shipping address',
    customParamsRequired: 'Please complete custom requirements',
    orderSubmitResponseError: 'Order submission response with error:',
    submitFailed: 'Submit failed',
    submitFailedRetry: 'Submit failed, please retry',
    
    // 地址相关错误
    addressLoadFailed: 'Failed to load address list',
    addressSaveFailed: 'Failed to save address',
    
    // 支付相关错误
    paymentProcessFailed: 'Payment process failed',
    paymentProcessFailedRetry: 'Payment processing failed, please retry',
    airwallexPayUnavailable: 'Airwallex payment is temporarily unavailable',
    
    // 其他错误
    shareConfigFailed: 'Share configuration failed',
    qrGenerateFailed: 'Failed to generate QR code, please try again',
    componentLoadFailed: 'Component load failed, please try again later',
    
    // 定制相关错误
    customDataLoadFailed: 'Failed to get custom data'
  },

  // 功能菜单
  menu: {
    addressManagement: 'Address Management',
    orderHistory: 'Order History',
    customerService: 'Customer Service',
    settings: 'Settings',
    about: 'About Us'
  },

  // 其他
  misc: {
    // 时间相关
    justNow: 'Just now',
    minutesAgo: '{minutes} minutes ago',
    hoursAgo: '{hours} hours ago',
    daysAgo: '{days} days ago',
    
    // 数量相关
    pieces: 'pieces',
    items: 'items',
    total: 'Total',
    subtotal: 'Subtotal',
    
    // 状态相关
    enabled: 'Enabled',
    disabled: 'Disabled',
    available: 'Available',
    unavailable: 'Unavailable',
    
    // 操作相关
    viewAll: 'View All',
    showMore: 'Show More',
    collapse: 'Collapse',
    expand: 'Expand'
  }
}